import { Component, HostListener, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Utils } from '@/utils/utils';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('erp-frontend');

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(event: BeforeUnloadEvent) {
    event.preventDefault();
    return false;
  }

  /**
   * En cualquier <form>, Enter se comporta como Tab: avanza al siguiente campo en vez de
   * intentar enviar el formulario. No toca <textarea> (ahí Enter es salto de línea) ni
   * botones (Enter ya los "pulsa" de forma nativa). Algunos campos manejan su propio Enter
   * (p.ej. las barras de búsqueda de producto) y cortan la propagación con stopPropagation()
   * para no pelear con esto.
   */
  @HostListener('document:keydown.enter', ['$event'])
  onEnterAdvancesFocus(event: Event) {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    const tag = target.tagName;
    const inputType = tag === 'INPUT' ? (target as HTMLInputElement).type : '';
    const isEditable = tag === 'SELECT' || (tag === 'INPUT' && !['submit', 'button', 'reset'].includes(inputType));
    if (!isEditable) return;

    if (!target.closest('form')) return;

    // El form ya tiene (submit)="false"/(ngSubmit)=... propio en cada página; cortamos aquí
    // el intento nativo de enviar el formulario al pulsar Enter.
    event.preventDefault();

    Utils.focusNextFormField(target);
  }
}
